import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getCampaignById = (id, parameters = null) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/campaing/query/${id}${getUrlParameters(parameters)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CAMPAIGN_BY_ID,
        ActionTypes.FETCHED_CAMPAIGN_BY_ID,
        [
          ActionTypes.FETCHED_CAMPAIGN_BY_ID_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addCampaign = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/campaing',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_CAMPAIGN,
        [
          ActionTypes.ADDED_CAMPAIGN,
          MessageActions.addMessageBoxInfo('Registro Guardado'),
        ],
        [
          ActionTypes.ADDED_CAMPAIGN_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};


export const updateCampaign = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/campaing',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_CAMPAIGN,
        [
          ActionTypes.UPDATED_CAMPAIGN,
          MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_CAMPAIGN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};

export const sendCampaignNotification = (data = {}) =>
  apiActionCreator({
    'endpoint': '/campaing/notification',
    'authenticated': true,
    'types': [
      ActionTypes.SENDING_CAMPAIGN_NOTIFICATION,
      [
        ActionTypes.SENDED_CAMPAIGN_NOTIFICATION,
        MessageActions.addMessageBoxInfo('La notificación de campaña fue enviada correctamente'),
      ],
      [
        ActionTypes.SENDED_CAMPAIGN_NOTIFICATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': data,
  });

export const fetchCampaignAttachments = (id, data) => apiActionCreator({
  'endpoint': `/campaign/${id}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CAMPAIGN_ATTACHMENTS,
    ActionTypes.FETCHED_CAMPAIGN_ATTACHMENTS,
    [
      ActionTypes.FETCHED_CAMPAIGN_ATTACHMENTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'GET',
});

export const saveCampaignAttachments = (id, data) => apiActionCreator({
  'endpoint': `/campaign/${id}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_CAMPAIGN_ATTACHMENTS,
    [
      ActionTypes.SAVED_CAMPAIGN_ATTACHMENTS,
      MessageActions.addMessageBoxInfo('Adjuntos guardados satisfactoriamente'),
    ],
    [
      ActionTypes.SAVED_CAMPAIGN_ATTACHMENTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'POST',
  data,
});

export const clearCampaign = () => {
  return {
    'type': ActionTypes.CLEAR_CAMPAIGN,
  };
};

export const setCampaignAttachments = (files) => ({
  'type': ActionTypes.SET_CAMPAIGN_FILES,
  'payload': files,
});
